const YOUTUBE_FACADE_SELECTOR = ".youtube-facade:not([data-youtube-loaded])"

const activateYouTubeFacade = (facade: HTMLElement): void  => {
  if (facade.dataset.youtubeLoaded === "true") {
    return
  }

  const videoId = facade.dataset.youtubeId
  if (!videoId) {
    return
  }

  facade.dataset.youtubeLoaded = "true"

  const iframe = document.createElement("iframe")
  iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`
  iframe.title = facade.getAttribute("aria-label") ?? "YouTube video"
  iframe.width = "750"
  iframe.height = "422"
  iframe.loading = "lazy"
  iframe.setAttribute(
    "allow",
    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  )
  iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin")
  iframe.allowFullscreen = true

  facade.replaceChildren(iframe)
  facade.classList.add("youtube-facade--loaded")
  facade.removeAttribute("role")
  facade.removeAttribute("tabindex")
}

const bindYouTubeFacade = (facade: HTMLElement): void  => {
  if (facade.dataset.youtubeBound === "true") {
    return
  }

  facade.dataset.youtubeBound = "true"

  const activate = (): void => {
    activateYouTubeFacade(facade)
  }

  facade.addEventListener("click", activate)

  facade.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      activate()
    }
  })
}

export const initYouTubeFacades = (root: ParentNode = document): void  => {
  if (typeof document === "undefined") {
    return
  }

  root.querySelectorAll<HTMLElement>(YOUTUBE_FACADE_SELECTOR).forEach(bindYouTubeFacade)
}
